export const getDeviceType = () => {
    const { userAgent } = navigator;
    if (/mobile/i.test(userAgent)) return 'mobile';
    if (/iPad|iPhone|iPod/.test(userAgent)) return 'tablet';
    return 'desktop';
};
